import { render, staticRenderFns } from "./SettingsCocurricularClubs.vue?vue&type=template&id=e93daee6"
import script from "./SettingsCocurricularClubs.vue?vue&type=script&lang=js"
export * from "./SettingsCocurricularClubs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports